module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABSBAMAAAA1Ap6oAAAAGFBMVEUfGhcfGhcfGhcfGhcfGhcfGhcfGhcfGhdyRvOWAAAAB3RSTlPupq2b3rdsQ9/1VQAAADxJREFUSMftyiEBACAMRNETFEARAIGlDZ4Ec6u/Cicn/tNPV56hkyYtMwaTyWQymUwmk8lkNpovTfrTswvaAdh6gyLn9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/L4.png
// module id = J9kO
// module chunks = 1